"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useManagerTimeoutBase = void 0;
const react_1 = require("react");
// Types
const types_1 = require("../types");
//TODO Usar una interfaz
const useManagerTimeoutBase = (timeout) => {
    const [dataTimeOut, setDataTimeOut] = (0, react_1.useState)(types_1.INITIAL_STATE);
    const goToPublic = () => {
        location.replace(window.PRIVATE_WEB_LOGOUT_URL);
    };
    const goToLogin = () => {
        location.replace(window.LOGIN_URL);
    };
    const update = (data) => {
        setDataTimeOut({ ...data });
    };
    const handleRefresh = () => {
        timeout.doRefresh();
    };
    const handleFinnish = () => {
        timeout.doFinnish();
    };
    (0, react_1.useEffect)(() => {
        timeout.setUpdate(update);
        timeout.checkTimeOut();
        return () => {
            timeout.clearTimer();
        };
    }, []);
    (0, react_1.useEffect)(() => {
        document.addEventListener('visibilitychange', () => {
            if (!document.hidden) {
                timeout.checkTimeOut();
            }
        });
    }, []);
    return {
        data: { ...dataTimeOut },
        redirect: {
            goToLogin,
            goToPublic,
        },
        handleRefresh,
        handleFinnish,
    };
};
exports.useManagerTimeoutBase = useManagerTimeoutBase;
//# sourceMappingURL=useManagerTimeoutBase.js.map